import React, { useState } from "react";
import {
  name,
  resume,
  profileLink,
  leetcodeProfile,
  profileImage,
  github,
  linkedin,
} from "../config/config";
import {
  FaUser,
  FaTools,
  FaProjectDiagram,
  FaEnvelope,
  FaBars,
  FaTimes,
  FaFileDownload,
  FaBriefcase,
  FaGithub,
  FaLinkedin,
} from "react-icons/fa";
import { BsStars } from "react-icons/bs";
import { SiLeetcode } from "react-icons/si";
import Gemini from "./Gemini";

const Header = ({ onOpenResume }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="text-white fixed top-4 left-1/2 transform -translate-x-1/2 w-[95%] max-w-7xl z-50 bg-white/5 backdrop-blur-xl border border-white/10 rounded-full px-6 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.3)] transition-all duration-300 hover:bg-white/10">
      <div className="flex justify-between items-center w-full">
        {/* Logo/Name */}
        <div className="flex items-center gap-3">
          <img
            src={profileImage}
            alt="Logo"
            className="w-9 h-9 rounded-full border-2 border-x-orange-400 border-y-purple-500 hover:scale-110 transform transition-transform duration-300 "
          />
          <Gemini message={name} fontSize={28} />
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6">
          <a
            href="#about"
            className="flex items-center hover:text-neon transition duration-300"
          >
            <FaUser className="mr-1" /> About
          </a>
          <a
            href="#experience"
            className="flex items-center hover:text-neon transition duration-300"
          >
            <FaBriefcase className="mr-1" /> Experience
          </a>
          <a
            href="#skills"
            className="flex items-center hover:text-neon transition duration-300"
          >
            <FaTools className="mr-1" /> Skills
          </a>
          <a
            href="#projects"
            className="flex items-center hover:text-neon transition duration-300"
          >
            <FaProjectDiagram className="mr-1" /> Projects
          </a>
          <a
            href="#contact"
            className="flex items-center hover:text-neon transition duration-300"
          >
            <FaEnvelope className="mr-1" /> Contact
          </a>
          <button
            onClick={(e) => { e.preventDefault(); onOpenResume(); }}
            className="flex items-center hover:scale-105 transition duration-300 font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500"
          >
            <BsStars className="mr-2 text-yellow-400 animate-pulse" size={20} /> Resume AI
          </button>
          <a
            href={profileLink}
            className="flex items-center hover:text-neon transition duration-300"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiLeetcode className="mr-1" /> LeetCode
          </a>
        </nav>

        {/* Toggle Menu for Mobile */}
        <div className="md:hidden flex items-center">
          <button onClick={toggleMenu} className="focus:outline-none">
            {isMenuOpen ? (
              <FaTimes className="text-2xl" />
            ) : (
              <FaBars className="text-2xl" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isMenuOpen && (
        <nav className="md:hidden bg-black/80 backdrop-blur-2xl absolute top-20 left-0 w-full flex flex-col space-y-4 p-6 shadow-2xl border border-white/10 rounded-3xl">
          <a
            href="#about"
            className="flex items-center hover:text-neon transition duration-300"
            onClick={toggleMenu}
          >
            <FaUser className="mr-2" /> About
          </a>
          <a
            href="#experience"
            className="flex items-center hover:text-neon transition duration-300"
            onClick={toggleMenu}
          >
            <FaBriefcase className="mr-2" /> Experience
          </a>
          <a
            href="#skills"
            className="flex items-center hover:text-neon transition duration-300"
            onClick={toggleMenu}
          >
            <FaTools className="mr-2" /> Skills
          </a>
          <a
            href="#projects"
            className="flex items-center hover:text-neon transition duration-300"
            onClick={toggleMenu}
          >
            <FaProjectDiagram className="mr-2" /> Projects
          </a>
          <a
            href="#contact"
            className="flex items-center hover:text-neon transition duration-300"
            onClick={toggleMenu}
          >
            <FaEnvelope className="mr-2" /> Contact
          </a>
          <button
            onClick={(e) => { e.preventDefault(); toggleMenu(); onOpenResume(); }}
            className="flex items-center hover:scale-105 transition duration-300 font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 text-left w-full"
          >
            <BsStars className="mr-2 text-yellow-400 animate-pulse" size={20} /> Resume AI
          </button>
          <a
            href={profileLink}
            className="flex items-center hover:text-neon transition duration-300"
            target="_blank"
            rel="noopener noreferrer"
            onClick={toggleMenu}
          >
            <SiLeetcode className="mr-2" /> LeetCode
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
